module.exports = __webpack_public_path__ + "img/foto_vashego_buketa.3b4d0e6.webp";